import { useDesignMaxTheme } from "@/packages";
import { useGetGuide, type RefundInfoResponse } from "@/shared/server";
import { FONT } from "@/styles";
import { Center, Spinner, Table, Td, Text, Th, Tr } from "@chakra-ui/react";

export const Refund = () => {
    const { data } = useGetGuide<RefundInfoResponse>({ section: "refund" });
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const currentRefunds = data?.currentRefunds;
    const EMPTY_GROUP = Array.from({ length: 2 });
    const { isTablet, isMobile, isLaptop } = MEDIAS();

    const wrapperPCPadding = isLaptop ? "64px 0 " : "80px 0";

    return data ? (
        <Center
            as="section"
            p={isMobile ? "40px 0 40px 24px" : wrapperPCPadding}
            flexDir="column"
            rowGap={isTablet ? "32px" : "64px"}
        >
            <Center flexDir="column">
                <Text textAlign="center" {...FONT("cormorant", isMobile ? 32 : 52, 500, 1.2)}>
                    Pension Refund
                </Text>
                <Text fontFamily="Cormorant">환불 규정</Text>
            </Center>
            <Center w="100%" overflow={isTablet ? "auto" : ""} justifyContent={isTablet ? "flex-start" : "center"}>
                <Table
                    w="100%"
                    boxSizing="border-box"
                    borderTop={`1px solid ${COLORS.gray[400]}`}
                    sx={{
                        borderCollapse: "collapse",
                        "& tr": {
                            height: "48px",
                            boxSizing: "border-box",
                        },
                        "& th,td": {
                            whiteSpace: "noWrap",
                            padding: "0 8px",
                            ...FONT("pretendard", 16, 300),
                            textAlign: "center",
                            borderBottom: `1px solid ${COLORS.gray[400]}`,
                        },
                        "& th": {
                            color: COLORS.gray[400],
                            background: COLORS.beige,
                        },
                    }}
                >
                    {EMPTY_GROUP.flatMap((_, trIdx) => (
                        <Tr>
                            {trIdx === 0 &&
                                currentRefunds?.map(
                                    (refund, idx) =>
                                        idx > 0 && <Th key={refund.beforeDate}>숙박 {refund.beforeDate}일전</Th>,
                                )}
                            {trIdx === 1 &&
                                currentRefunds?.map(
                                    (refund, idx) => idx > 0 && <Td key={refund.refund}>{refund.refund} 환불</Td>,
                                )}
                        </Tr>
                    ))}
                </Table>
            </Center>
        </Center>
    ) : (
        <Spinner />
    );
};
